import { render, staticRenderFns } from "./CompDetectSummary.vue?vue&type=template&id=0d17b91c"
import script from "./CompDetectSummary.vue?vue&type=script&lang=js"
export * from "./CompDetectSummary.vue?vue&type=script&lang=js"
import style0 from "./CompDetectSummary.vue?vue&type=style&index=0&id=0d17b91c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports